import React, { useContext } from "react";
import styled from "styled-components";

import { RichContentDisplay } from "@examspark/common-ui";

import ItemFontScaling from "./ItemFontScaling";
import QuestionContext from "./QuestionContext";

const getBucketUrl = (file) => {
  return `https://${file.bucket}.s3.amazonaws.com/${file.key}`;
};

const Wrapper = styled.div`
  line-height: 1.5em;

  img {
    max-width: 100%;
  }

  p {
    line-height: 1.5em;
  }
`;

const Passage = (props) => {
  if (!props?.data?.content?.body) {
    return false;
  }

  return (
    <Wrapper>
      {props?.data?.content?.body && (
        <RichContentDisplay content={props?.data?.content?.body} />
      )}
      {!props?.data?.content?.body && <div>[No Content]</div>}
    </Wrapper>
  );
};

const Audio = (props) => {
  if (!props?.data?.file) {
    return false;
  }

  let src = getBucketUrl(props.data.file);

  return (
    <div>
      <audio controls controlList="nodownload">
        <source src={src} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

const Video = (props) => {
  if (!props?.data?.file) {
    return false;
  }

  let src = getBucketUrl(props.data.file);

  return (
    <div>
      <video controls="controls" controlsList="nodownload" width="100%">
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
};

const Image = (props) => {
  if (!props?.data?.file) {
    return false;
  }

  let src = getBucketUrl(props.data.file);

  return (
    <div>
      <img src={src} />
    </div>
  );
};

const Context = (props) => {
  const [state] = useContext(QuestionContext);

  return (
    <ItemFontScaling fontScaling={state?.fontScaling}>
      <InnerContext {...props} />
    </ItemFontScaling>
  );
};

export default Context;

const InnerContext = (props) => {
  switch (props?.data?.type) {
    case "PASSAGE":
      return <Passage {...props} />;
    case "AUDIO":
      return <Audio {...props} />;
    case "VIDEO":
      return <Video {...props} />;
    case "IMAGE":
      return <Image {...props} />;
    default:
      return <></>;
  }
};
